import { UseQueryOptions, useSuspenseQuery } from '@tanstack/react-query'
import Consultation from '~models/consultation'
import ConsultationRepository from '~repositories/impl/consultation-repository'
import { MODEL_QUERY_KEYS } from './query-keys'

export type FetchConsultationDetailParam = Readonly<
  Pick<UseQueryOptions<Consultation.Level2, Error>, 'staleTime' | 'gcTime'> & {
    id: string | number
  }
>

const useConsultationDetail = ({ ...params }: FetchConsultationDetailParam) => {
  return useSuspenseQuery({
    ...params,
    staleTime: params.staleTime || 0,
    gcTime: params.gcTime || 5 * 60 * 1000,
    queryKey: MODEL_QUERY_KEYS.consultation.level2(params.id),
    queryFn: () => ConsultationRepository.getConsultationDetail(params.id),
    retry: 1,
  })
}

export default useConsultationDetail
